<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.organName" placeholder="公司名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getUsers">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<!--<el-table-column type="selection" width="55">
			</el-table-column>-->
			<el-table-column type="index" width="60">
			</el-table-column>
			<el-table-column prop="name" label="公司名称" width="200" sortable>
			</el-table-column>
			<el-table-column prop="upper_sysno" label="所属设备编号" width="150" sortable>
			</el-table-column>
			<el-table-column prop="account" label="账号" width="180" sortable>
			</el-table-column>
			<el-table-column prop="creat_time" label="创建时间" min-width="120" sortable>
			</el-table-column>
			<el-table-column label="操作" width="280">
				<!--VerifyShow
				'handleEdit'-->
				<template slot-scope="scope">
					<el-button size="small" @click="VerifyShow('handleEdit',scope.$index, scope.row)">修改</el-button>
					<el-button size="small" type="warning" plain @click="VerifyShow('passwordUpDate',scope.$index, scope.row)">密码重设</el-button>
					<el-button type="danger" :disabled="scope.row.upper_sysno==GLOBAL.admin.upperSysno" size="small" @click="VerifyShow('handleDel',scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除{{addFormVisible}}</el-button>-->
			<el-pagination layout="prev, pager, next,jumper"  @current-change="handleCurrentChange"  :page-size="size" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<!--<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">-->
		<el-dialog title="编辑机构" :visible.sync="editFormVisible">
			<el-form :model="editForm" label-width="110px" ref="editForm">
				<el-form-item label="公司全称" prop="name" >
					<el-input v-model="editForm.name" prop="name"></el-input>
				</el-form-item>
				<el-form-item label="账户号">
					<el-input @keyup.native='accountRules' v-model="editForm.account" prop="account"></el-input>
				</el-form-item>
				<el-form-item label="公司简称">
					<el-input @keyup.native='accountRules' v-model="editForm.shortname" prop="shortname"></el-input>
				</el-form-item>
				<el-form-item label="所属设备编号" >
					<el-input type='number' v-model="editForm.upper_sysno" prop="upper_sysno"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" >
					<el-input type='number' v-model="editForm.phone" prop="phone"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
		<!--新增-->
		<el-dialog title="添加机构" :visible.sync="addFormVisible">
		  <!--<el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm">-->
		  	<el-form :model="addForm" label-width="110px" ref="addForm">
				<el-form-item label="公司名称" prop="name">
					<el-input v-model="addForm.name" ></el-input>
				</el-form-item>
				<el-form-item label="所属设备编号" >
					<el-input type='number' v-model="addForm.upper_sysno" prop="upper_sysno"></el-input>
				</el-form-item>
				<el-form-item label="账户号">
					<el-input @keyup.native='accountRules' v-model="addForm.account" prop="account"></el-input>
				</el-form-item>
				<el-form-item label="密码">
					<el-input type='password' v-model="addForm.password" ></el-input>
				</el-form-item>
				<!--<el-form-item label="地址">
					<el-input type="textarea" v-model="addForm.addr"></el-input>
				</el-form-item>-->
			</el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="addFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click.native="addSubmit" :loading="addLoading">确 定</el-button>
		  </div>
		</el-dialog>
		<!--密码重设-->
		<el-dialog title="重设密码" :visible.sync="passwordUpDateVisible">  
		  	<el-form  label-width="110px" >
				<el-form-item label="输入新密码" >
					<el-input v-model="passwordchange.passwordNew" ></el-input>
				</el-form-item>
			</el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="passwordUpDateVisible = false">取 消</el-button>
		    <el-button type="primary" @click.native="changePassword" :loading="addLoading">确 定</el-button>
		  </div>
		</el-dialog>
		<!--发送验证码-->
		<el-dialog title="请选择管理员以验证权限" :visible.sync="phoneVerifyShow" id="phoneVerify">  
	  	 	<el-select v-model="admin.account" placeholder="请选择">
			    <el-option v-for="item in GLOBAL.adminUsers" :key="item.account" :label="item.name"	:value="item.account"></el-option>
		  	</el-select>
		  	<el-button    @click="send_phonenumber" :disabled="sendVerify!='发送验证码'&&sendVerify!='重新发送'" >{{sendVerify}}</el-button>
		  	<el-input  maxlength="4" v-model="admin.code" placeholder="请输入验证码" ></el-input>
	  	<div slot="footer" class="dialog-footer">
		    <el-button @click="phoneVerifyShow = false">取 消</el-button>
		    <el-button type="primary" @click.native="phonenumber_verify" :loading="addLoading">验 证</el-button>
	  	</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { getOrganList, removeOrgan, batchRemoveUser, editUser, add_organ ,edit_organPassword,sendPhoneNumber,phoneVerify } from '../api/api';

	export default {
		data() {
			return {
				filters: {
					organName: ''
				},
				users: [],
				total: 0,
				page: 1,
				size:10,
				listLoading: false,
				sels: [],//列表选中列
				//
				dialogFormVisible: false,
				form: {
		          	name: '',
		          	region: '',
		          	date1: '',
		          	date2: '',
		          	delivery: false,
		          	type: [],
		          	resource: '',
		          	desc: ''
	        	},
	        	formLabelWidth: '120px',
	        	//编辑界面是否显示
				editFormVisible: false,
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入公司名称', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					name: '',
					sysno: '',
					upper_sysno: '',
					account: '',
					shortname:'',
					phone:''
				},
				//新增界面是否显示
				addFormVisible: false,
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入公司名称', trigger: 'blur' },
					],
				},
				//新增界面数据
				addForm: {
					name: '',
					upper_sysno:'',
					account: '',
					password: '',
				},
				//密码重设界面是否显示
				passwordUpDateVisible:false,
				passwordchange:{
					passwordNew:'',
					organ_sysno:''
				},
				//验证码发送界面是否显示
				phoneVerifyShow:false,
				sendVerify:'发送验证码',
				admin:{
					account:'',
					code:'',
				},
				operation:'',
				index:'',
				row:'',
			}
		},
		methods: {
			//性别显示转换
			formatSex: function (row, column) {
				return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getUsers();
			},
			//获取用户列表
			getUsers() {
				let para = {
					organName:this.filters.organName.trim(),
					pageNo:this.page,
					pageSize:this.size,
				};
				this.listLoading = true;
				//NProgress.start();
				getOrganList(para).then((res) => {
					console.log(res)
					this.total = res.data.data.rowcount;
					this.users = res.data.data.list;
					this.listLoading = false;
					//NProgress.done();
				});
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该机构吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { sysno: row.sysno };
					removeOrgan(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getUsers();
					});
				}).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm.sysno=row.sysno
				this.editForm.name=row.name
				this.editForm.account=row.account
				this.editForm.upper_sysno=row.upper_sysno
				this.editForm.shortname=row.organ_sortname
				this.editForm.phone=row.organ_phone
			},
			//显示验证码发送界面
			VerifyShow:function(operation,index,row){
				this.phoneVerifyShow=true
				this.admin.account=''
				this.admin.code=''
				this.operation=operation
				this.index=index
				this.row=row
			},
			//显示密码重设界面
			passwordUpDate:function(index, row){
				this.passwordUpDateVisible=true
				console.log(index, row)
				this.passwordchange.organ_sysno=row.sysno
				this.passwordchange.passwordNew=''
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm.account='';
				this.addForm.name='';
				this.addForm.upper_sysno='';
				this.addForm.password=''
			},
			accountRules:function(){//账户号正则校验
				this.addForm.account = this.addForm.account.replace(/[^\w\/]/ig,'')
				this.editForm.account = this.editForm.account.replace(/[^\w\/]/ig,'')
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认修改吗？', '提示', {}).then(() => {
							console.log(valid)
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							//para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							editUser(para).then((res) => {
								this.editLoading = false;
								if(res.data.data.result==1){
									this.$message({
										message: '修改成功',
										type: 'success'
									});
								}else if(res.data.data.result==2){
									this.$message({
										message: '修改失败， 数据错误',
										type: 'error'
									});
								}else{
									this.$message({
										message: '修改失败，已有重复数据',
										type: 'error'
									});
								}
								//NProgress.done();
								
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.getUsers();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						console.log(valid)
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							console.log(this.addForm)
							let para = Object.assign({}, this.addForm);
							console.log(para)
//							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							add_organ(para).then((res) => {
								console.log(res)
								this.addLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								this.getUsers();
							});
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			changePassword:function(){
				if(this.passwordchange.passwordNew==''){
					this.$message({
							message: '请输入新密码',
							type: 'error'
						});
					return
				}
				this.$confirm('确认提交吗？', '提示', {}).then(() => {
					this.addLoading = true;
					//NProgress.start();
					let para = Object.assign({}, this.passwordchange);
					console.log(para)
					edit_organPassword(para).then((res) => {
						this.addLoading = false;
						if(res.data.data.result==1){
							this.$message({
								message: '提交成功',
								type: 'success'
							});
							this.passwordUpDateVisible=false
						}else if(res.data.data.result==3){
							this.$message({
								message: '参数错误',
								type: 'error'
							});
						}else{
							this.$message({
								message: '未知错误',
								type: 'error'
							});
						}
						this.getUsers();
					});
				});
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					batchRemoveUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getUsers();
					});
				}).catch(() => {

				});
			},
			send_phonenumber:function(){
				if(this.admin.account==''){
					this.$message({
							message: '请选择管理员用户',
							type: 'error'
						});
					return
				}
				this.$confirm('确认发送吗？', '提示', {}).then(() => {
					var that=this
					var ticketid = new Date().getTime();
					var para={
						TicketId:ticketid,
						Mobile:this.admin.account
					}
					var i=60;
					that.sendVerify=i
					var timer= setInterval(function(){
						i--;
						that.sendVerify=i
						if(i==0){
							that.sendVerify='重新发送'
							clearInterval(timer)
						}
					},1000)
					sendPhoneNumber(para).then((res) => {
						console.log(res.data)
						if(res.data.Status=='OK'&&res.data.ResponseData.Status==1){
							this.$message({
								message: '发送成功',
								type: 'success'
							});
						}
					})
				}).catch((res)=>{
					console.log('取消')
				})
			},
			phonenumber_verify:function(){
				if(this.admin.code==''){
					this.$message({
							message: '请输入验证码',
							type: 'error'
						});
					return
				}
				var that=this
				var ticketid = new Date().getTime();
				var para={
					TicketId:ticketid,
					Mobile:this.admin.account,
					Code:this.admin.code
				}
				phoneVerify(para).then((res) => {
					console.log(res.data)
					if(res.data.response.Status=='OK'&&res.data.response.ResponseData.Status==1){
						that.phoneVerifyShow=false
						switch(that.operation){
							case 'passwordUpDate':
								that.passwordUpDate(that.index,that.row)
							break;
							case 'handleEdit':
								that.handleEdit(that.index,that.row)
							break;
							case 'handleDel':
								that.handleDel(that.index,that.row)
							break;
						}
					}else{
						that.$message({
							message: '验证失败',
							type: 'error'
						});
					}
				})
			}
		},
		mounted() {
			this.getUsers();
		}
	}

</script>

<style lang="scss" slot-scope>
	#phoneVerify .el-dialog__body .el-select{
		margin: 20px;
	}
	#phoneVerify .el-dialog__body>.el-input{
		width: 20%;
		margin: 20px;
	}
	#phoneVerify .el-button{
		width: 112px;
	}
</style>


// WEBPACK FOOTER //
// src/components/organ.vue